import React, { useState, useEffect } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import { fetchAreas } from "../../../../redux/reducer/areaReducer";
const EditCategoryForm = ({
  editForm,
  onChange,
  onFileChange,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  const { areas } = useSelector((state) => state.areas);
  const dispatch = useDispatch();

  const [selectedAreaId, setSelectedAreaId] = useState(editForm.area || "");

  useEffect(() => {
    dispatch(fetchAreas());
  }, [dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(
      {
        ...editForm,
        area: selectedAreaId,
      },
      e
    );
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-2 gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      {/* Area Dropdown */}
      <div className="col-span-2">
        <label className="text-sm font-semibold text-black">Area</label>
        <select
          className="w-full px-3 py-2 text-sm text-black bg-gray-100 border rounded-md"
          value={selectedAreaId}
          onChange={(e) => setSelectedAreaId(e.target.value)}
        >
          <option value="" className="text-black">
            Choose Area
          </option>
          {areas?.map((area) => (
            <option key={area._id} value={area._id} className="text-black">
              {area.name?.en}
            </option>
          ))}
        </select>
      </div>
      <hr className="col-span-2 my-2" />
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (EN)</label>
        <input
          type="text"
          name="nameEn"
          value={editForm.nameEn}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (AR)</label>
        <input
          type="text"
          name="nameAr"
          value={editForm.nameAr}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col ">
        <label className="text-sm font-semibold text-black">Image</label>
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={onFileChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        {isLoading ? null : (
          <button
            className="px-4 py-2 text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
        {isLoading ? (
          <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
        ) : (
          <button
            type="submit"
            className="px-4 py-2 text-white duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-600"
          >
            Submit
          </button>
        )}
      </div>
    </form>
  );
};

export default EditCategoryForm;
